import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import cx from "classnames";
import { rem } from "polished";
import type { ReactElement } from "react";
import styled, { css } from "styled-components";

import { DragVertical } from "./drag-vertical";

type SortableItemProps = {
  children: ReactElement;
  id: string;
};

const Container = styled.div<{ isDragging: boolean }>`
  position: relative;
  display: flex;
  border: 1px solid var(--color-gray-300);
  background-color: #fff;
  margin-bottom: ${rem(8)};
  border-radius: ${rem(8)};

  ${({ isDragging }) =>
    isDragging &&
    css`
      z-index: 10;
    `}
`;

const SortableItem = (props: SortableItemProps) => {
  const { children, id } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Container ref={setNodeRef} style={style} isDragging={isDragging}>
      <div
        {...attributes}
        {...listeners}
        className={cx("flex items-center p-2", {
          "cursor-grabbing": isDragging,
          "cursor-grab": !isDragging,
        })}
      >
        <DragVertical className="text-grey-50" />
      </div>
      {children}
    </Container>
  );
};

export default SortableItem;
